import { render } from "./TableActions.vue?vue&type=template&id=4947605c&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=4947605c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4947605c"

export default script